import { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../../services/api";
import "./inventory-category.css";

export default function InventoryCategoryAdd() {
  const school   = JSON.parse(localStorage.getItem("schoolAdmin"));
  const navigate = useNavigate();

  const [name,    setName]    = useState("");
  const [saving,  setSaving]  = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return alert("Enter category name");
    try {
      setSaving(true);
      await API.post(
        "/school-admin/inventory/categories/",
        { name },
        { headers: { "X-SCHOOL-ID": school.school.id } }
      );
      navigate("/school-admin/inventory/categories");
    } catch (err) { console.error(err); alert("Error adding category"); }
    finally { setSaving(false); }
  };

  return (
    <div className="ic-page">

      {/* ══ HERO ══ */}
      <div className="ic-hero">
        <div className="ic-hero-left">
          <div className="ic-hero-icon">🗂</div>
          <div>
            <h2 className="ic-hero-title">Add Category</h2>
            <p className="ic-hero-sub">Create a new inventory category</p>
          </div>
        </div>
        <div className="ic-hero-right">
          <button className="ic-btn-back" onClick={() => navigate("/school-admin/inventory/categories")}>
            ← Back
          </button>
        </div>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="ic-form-card">
          <p className="ic-form-section-title">Category Details</p>

          <div className="ic-field">
            <label>Category Name *</label>
            <input
              required
              placeholder="e.g. Sports Equipment, Lab Supplies, Stationery"
              value={name}
              onChange={e => setName(e.target.value)}
            />
          </div>

          <button type="submit" className="ic-btn-submit" disabled={saving}>
            {saving
              ? <><div className="ic-spinner"></div> Saving…</>
              : "✓ Add Category"
            }
          </button>
        </div>
      </form>

    </div>
  );
}
